// Module
var code = `<div class="ii-customer" role="cell">
  <img
    src="{{attrImageSrc}}"
    class="rounded-full"
    width="28"
    height="28"
    alt="{{attrImageAlt}}"
  />
  <p>{{name}}</p>
</div>
<p class="ii-email" role="cell">{{email}}</p>
<div
  class="ii-amount ii-cell"
  role="cell"
  data-event-type="invoiceCell"
  data-field="amount"
  data-invoice-id="{{attrInvoiceId}}"
>
  <span data-slot="cell-text">{{amount}}</span>
</div>
<div
  class="ii-date ii-cell"
  role="cell"
  data-event-type="invoiceCell"
  data-field="date"
  data-invoice-id="{{attrInvoiceId}}"
>
  <span data-slot="cell-text">{{date}}</span>
</div>
<div
  class="ii-status ii-cell"
  role="cell"
  data-event-type="invoiceCell"
  data-field="status"
  data-invoice-id="{{attrInvoiceId}}"
>
  <button
    type="button"
    class="{{attrStatusClass}}"
    data-event-type="acmeData"
    data-btn-type="toggle-invoice-status"
    data-invoice-id="{{attrInvoiceId}}"
    title="Toggle paid / pending"
  >
    {{#isPending}}{{label}}{{svgClock}}{{/isPending}}
    {{#isPaid}}{{label}}{{svgCheck}}{{/isPaid}}
  </button>
</div>
<div class="ii-actions" role="cell">
  <a
    class="rounded-md border p-2 hover:bg-gray-100"
    href="{{attrEditHref}}"
    data-event-type="acmeInvoices"
    data-btn-type="edit"
    data-invoice-id="{{attrInvoiceId}}"
    data-event-prevent-default="true"
  >
    {{svgPencil}}
    <span class="sr-only">Edit</span>
  </a>
  <button
    type="button"
    class="rounded-md border p-2 hover:bg-gray-100"
    data-event-type="acmeData"
    data-btn-type="delete-invoice"
    data-invoice-id="{{attrInvoiceId}}"
  >
    {{svgTrash}}
    <span class="sr-only">Delete</span>
  </button>
</div>
`;
// Exports
module.exports = code;